import React from 'react';
import { cn } from '@lib/utils.ts';

type ControlUnitProps = {
  minWidth?: number;
  className?: string;
  active?: boolean;
  value: string;
  isFullWidth?: boolean;
};

export const ControlUnit: React.FC<ControlUnitProps> = ({
  className,
  minWidth = 28,
  active,
  value,
  isFullWidth,
}) => {
  return (
    <div
      className={cn(
        `flex h-[21px] border-[0.6px] rounded-[2px] items-center justify-center px-[2px]`,
        active
          ? 'bg-[#14CA7433] border-[#14CA7480]'
          : 'bg-[#C72E2E33] border-[#C72E2E80]',
        isFullWidth ? 'w-full' : '',
        className
      )}
      style={{ minWidth: `${minWidth}px` }}
    >
      {value}
    </div>
  );
};
